import { render, staticRenderFns } from "./xtSupReportList.vue?vue&type=template&id=e1f494ec"
import script from "./xtSupReportList.vue?vue&type=script&lang=js"
export * from "./xtSupReportList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports